var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiantDollorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8388 14.9206V12.0612H21.4502V18.8219C20.7153 19.5165 19.6486 20.13 18.25 20.6625C16.8593 21.1873 15.4488 21.4497 14.0186 21.4497C12.2012 21.4497 10.6169 21.0793 9.26566 20.3384C7.91446 19.5898 6.89908 18.5247 6.21952 17.1433C5.53997 15.7541 5.2002 14.2453 5.2002 12.6169C5.2002 10.8495 5.57948 9.27896 6.33805 7.90521C7.09662 6.53147 8.20682 5.478 9.66865 4.74482C10.7828 4.18143 12.1696 3.89974 13.8289 3.89974C15.9861 3.89974 17.6692 4.3435 18.8782 5.23104C20.095 6.11085 20.8773 7.33024 21.225 8.88922L17.7403 9.52592C17.4954 8.69241 17.0331 8.03641 16.3536 7.55792C15.6819 7.0717 14.8404 6.8286 13.8289 6.8286C12.296 6.8286 11.0752 7.30323 10.1665 8.25251C9.26566 9.20178 8.81526 10.6103 8.81526 12.4779C8.81526 14.4923 9.27356 16.0049 10.1902 17.0159C11.1068 18.0192 12.3078 18.5209 13.7934 18.5209C14.5282 18.5209 15.2631 18.382 15.998 18.1041C16.7407 17.8186 17.3768 17.4751 17.9063 17.0738V14.9206H15.8388Z",
    fill: "#70BF45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3501 14.9503L2.6001 14.9503",
    stroke: "#70BF45",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3501 11.7003L2.6001 11.7003",
    stroke: "#70BF45",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiantDollorGreen);
export default __webpack_public_path__ + "static/media/GiantDollor_Green.3eb348a4a74589736ad3dc3a2731efa7.svg";
export { ForwardRef as ReactComponent };